import { createContext, Dispatch, SetStateAction } from "react";

import { OrganizationDetails } from "@organization/models/OrganizationDetails";

interface OrganizationContextType {
  organization: OrganizationDetails;
  setOrganization: Dispatch<SetStateAction<OrganizationDetails>>;
}

export const OrganizationContext = createContext<OrganizationContextType>({
  organization: {} as OrganizationDetails,
  setOrganization: () => {}
});
